import { makeStyles } from "@material-ui/core/styles";

export const layoutStyles = makeStyles(({ palette, ...theme }) => ({
  "@global": {},
}));
